<template>
	<div class="contianer main-content">

		<div class="row">
			
			<div class="col-12 header-container text-center pb-2">
				<h4 class="dark-highlight"><strong>Please complete your payment</strong></h4>
			</div>

			<div class="col-12 col-sm-8 offset-sm-2 text-center">
				<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>

		</div>

		<div class="row">

			<div class="col-12 text-center">
				<a href="http://www.polipayments.com/consumer"><img src="https://resources.apac.paywithpoli.com/poli-logo-44.png" width="221" height="100" alt="POLi Payments"/></a>
			</div>

			<div class="col-12 col-md-6 offset-md-3 pt-4 text-center">
				<p>Please complete your payment using our partner <strong>POLi&nbsp;Payments</strong>.  Click the button below when you are ready.</p>
				<small class="error" v-if="hasError">{{ errorMessage }}</small>
			</div>
			
		</div>

		<div class="row mt-4">
			<div class="col-12 text-center">
				<a href="#" id="payment-success-next" class="btn next-btn" v-if="!isProcessing" :class="{'disabled' : isProcessing }" ref="btnNext" v-on:click.prevent="proceed">Proceed</a>
				<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">Please wait... <i class="fas fa-circle-notch fa-spin"></i></a>
			</div>
		</div>
		
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data(){
        return {
			isProcessing: false,
			hasError: false,
			errorMessage: '',
        }
	},
    methods: {
        proceed: function (){
            if(this.isProcessing){
				return;
			}

			this.isProcessing = true;
			this.hasError = false;

			this.$gstate.log("init poli ...");

			var urlstr = this.$gstate.getApiBaseRootURL() + '/banktransfer/init';
			this.axios.post(urlstr,{
				refId: this.$gstate.getRefId(),
				selectedBank: ""
			}, 
			this.$gstate.getAxiosHeaders()
			).then(response => {

					this.$gstate.log(response);
					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {

					this.$gstate.log("error:");
					this.$gstate.log(error.response);
					
					this.isProcessing = false;					
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;
					
				});
				
        }
    }
}
</script>
